import React from "react";
import { Badge } from "antd";
import colors from "constants/colors";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";

dayjs.extend(isBetween);

interface Props {
  deadline: string;
  created_at: string;
  children?: React.ReactNode;
}

const RibbonStatusBadge: React.FC<Props> = ({ deadline, created_at, children }) => {
  let ribbonText = "";

  const getStatusTextAndColor = () => {
    if (dayjs().isSame(dayjs(deadline), "day")) {
      ribbonText = "Siste frist";
      return colors.red;
    }

    if (dayjs(created_at).isBetween(dayjs().subtract(7, "day"), dayjs())) {
      ribbonText = "Ny denne uken";
      return colors.green;
    }
    return undefined;
  };
  const ribbonColor = getStatusTextAndColor();

  return (
    <>
      {ribbonColor === undefined ? (
        <>{children}</>
      ) : (
        <Badge.Ribbon text={ribbonText} color={ribbonColor}>
          {children}
        </Badge.Ribbon>
      )}
    </>
  );
};

export default RibbonStatusBadge;
